import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";

import UserActions from "./UserActions";

interface UserRowProps {
  user: {
    id: string;
    first_name: string;
    last_name: string;
    email: string;
    isAdmin: boolean;
    isActive: boolean;
  };
  onRoleChange: (userId: string, makeAdmin: boolean) => Promise<void>;
  onStatusChange: (userId: string, makeActive: boolean) => Promise<void>;
  onDeleteUser: (userId: string) => Promise<void>;
}

const UserRow = ({ user, onRoleChange, onStatusChange, onDeleteUser }: UserRowProps) => {
  return (
    <TableRow className="border-gray-200 hover:bg-gray-50">
      <TableCell className="font-medium text-gray-900">
        {user.first_name || user.last_name ? `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() : "Unnamed user"}
      </TableCell>
      <TableCell className="text-gray-500">{user.email}</TableCell>
      <TableCell>
        <Badge
          variant="outline"
          className={
            user.isActive
              ? "border-emerald-200 bg-emerald-50 text-emerald-700"
              : "border-gray-200 bg-gray-100 text-gray-600"
          }
        >
          {user.isActive ? "Active" : "Inactive"}
        </Badge>
      </TableCell>
      <TableCell>
        <Badge
          variant="outline"
          className={
            user.isAdmin
              ? "border-whatsapp/20 bg-whatsapp-light text-whatsapp"
              : "border-gray-200 bg-gray-100 text-gray-600"
          }
        >
          {user.isAdmin ? "Admin" : "User"}
        </Badge>
      </TableCell>
      <TableCell className="text-right">
        <UserActions
          userId={user.id}
          isAdmin={user.isAdmin}
          isActive={user.isActive}
          onRoleChange={onRoleChange}
          onStatusChange={onStatusChange}
          onDeleteUser={onDeleteUser}
        />
      </TableCell>
    </TableRow>
  );
};

export default UserRow;
